import { motion } from 'framer-motion';

/**
 * Lightweight scroll-into-view reveal wrapper.
 * Usage: <Reveal delay={0.1}>...</Reveal>
 */
const variants = {
  hidden: { opacity: 0, y: 28 },
  visible: (delay) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Reveal({ children, delay = 0, as = 'div', className, style, ...rest }) {
  const MotionTag = motion[as];
  return (
    <MotionTag
      className={className}
      style={style}
      variants={variants}
      custom={delay}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-80px' }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
